import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

@inject('InventoryStore')
@observer
class Inventory extends Component {
    render() {
        return (
            <Fragment>
                <InventoryHeader title="Quick Stock Update" backLink="" />
                <div className="inventory-menu">
                    <h2>{moment().format('dddd - DD/MM/YYYY')}</h2>
                    <div className="btn-wrapper mm mtxl">
                        <Link
                            to={`/inventory/adjustment/meals`}
                            onClick={this.props.InventoryStore.handleSetCurrentSku(
                                ''
                            )}
                        >
                            <button className="btn btn-primary width--300px">
                                Meals
                            </button>
                        </Link>
                    </div>
                    <div className="btn-wrapper mm">
                        <Link
                            to={`/inventory/adjustment/addons`}
                            onClick={this.props.InventoryStore.handleSetCurrentSku(
                                ''
                            )}
                        >
                            <button className="btn btn-primary width--300px">
                                Addons
                            </button>
                        </Link>
                    </div>
                    <div className="btn-wrapper mm">
                        <Link
                            to={`/inventory/adjustment/component`}
                        >
                            <button className="btn btn-primary width--300px">
                                Component
                            </button>
                        </Link>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Inventory;
